<template>
    <FilterCompoennt :data="data" />
    <div class="gallery_board_list">
        <router-link :to="`./bridging_volunteer/${post.idx}`" class="gallery_board_list_item" v-for="post of data.list"
            :key="post.idx">
            <div class="thumbnail_area">
                <img :src="post.thumbPath" alt="" @error="setDefaultImage" />
                <span class="top"></span>
                <span class="right"></span>
                <span class="bottom"></span>
                <span class="left"></span>
            </div>
            <div class="content_area">
                <div class="title">{{ post.subject }}</div>
                <div class="date">{{ new Date(post.writeDate).toLocaleDateString('ko-KR') }}</div>
            </div>
        </router-link>
    </div>
    <PaginationComponent :data="data" />
</template>

<script>
import FilterCompoennt from '@/components/FilterCompoennt.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import defaultImagePath from '@/assets/no_image.png';

export default {
    components: {
        FilterCompoennt,
        PaginationComponent,
    },
    props: {
        data: {
            default: [],
        },
    },
    data() {
        return {
            defaultImagePath,
        };
    },
    methods: {
        setDefaultImage(event) {
            event.target.src = this.defaultImagePath; // 기본 이미지로 대체
        },
    },
};
</script>

<style lang="scss" scoped>
.gallery_board_list {
    width: 100%;
    max-width: 1540px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 70px 50px;

    @media screen and (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    .gallery_board_list_item {
        .thumbnail_area {
            position: relative;
            width: 100%;
            aspect-ratio: 480/310;
            margin-bottom: 25px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transform: scale(1);
                transform-origin: center;
                transition: 0.3s ease-in;
            }

            .top {
                width: 100%;
                height: 5px;
                position: absolute;
                top: 0;
                left: 0;
                background: var(--orange);
                transition: 0.1s linear;
                transform-origin: left;
                transform: scaleX(0);
            }

            .right {
                width: 5px;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                background: var(--orange);
                transition: 0.1s linear;
                transform-origin: top;
                transform: scaleY(0);
                transition-delay: 0.1s;
            }

            .bottom {
                width: 100%;
                height: 5px;
                position: absolute;
                bottom: 0;
                right: 0;
                background: var(--orange);
                transition: 0.1s linear;
                transform-origin: right;
                transform: scaleX(0);
                transition-delay: 0.2s;
            }

            .left {
                width: 5px;
                height: 100%;
                position: absolute;
                bottom: 0;
                left: 0;
                background: var(--orange);
                transition: 0.1s linear;
                transform-origin: bottom;
                transform: scaleY(0);
                transition-delay: 0.3s;
            }
        }

        .content_area {
            .title {
                font-weight: 700;
                font-size: 22px;
                margin-bottom: 30px;

                @media screen and (max-width: 768px) {
                    margin-bottom: 20px;
                    font-size: 18px;
                }
            }

            .date {
                font-size: 16px;
                color: #888;
            }
        }

        &:hover {
            .title {
                color: var(--orange);
                text-decoration: underline;
                text-underline-offset: 4px;
            }

            .thumbnail_area {
                img {
                    transform: scale(1.1);
                }

                .top {
                    transform: scaleX(1);
                }

                .right {
                    transform: scaleY(1);
                }

                .bottom {
                    transform: scaleX(1);
                }

                .left {
                    transform: scaleY(1);
                }
            }
        }
    }
}
</style>
